import { appendToFormData } from '~/utils/helper';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IJobType,
  IJobTypeCreate,
  IParamsGetJobType,
  IResponseGetJobType,
  IResponseGetJobTypes,
} from '~/utils/interface/jobType';
import { IPayloadDelete } from '~/utils/interface/customer';

const jobTypeApi = {
  getJobTypes() {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobTypes>>('api/admin/job-types');
  },
  getJobListTypes(params: IParamsGetJobType) {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobType>>('api/admin/job-types/list', { params });
  },
  create(data: IJobTypeCreate) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/job-types`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IJobType>>(`api/admin/job-types/${id}`);
  },
  update(id: string | undefined, data: IJobTypeCreate) {
    const formData = new FormData();
    appendToFormData(formData, data, '', ['files']);
    return axiosClient.put<IApiBaseResponse<IJobType>>(`api/admin/job-types/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>('api/admin/job-types', { data });
  },
};

export default jobTypeApi;
